import { ContentLayout } from 'components/Layout';
import { ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { RequestAccess } from '../RequestAccess';
import { Button } from '../Button';

export function ForbiddenFallback() {
  const navigate = useNavigate();
  return (
    <ContentLayout title="Access Restricted">
      <div className="rounded-2xl h-[50vh]  flex items-start gap-4 text-white">
        <div className="flex-shrink-0">
          <ShieldAlert className="w-10 h-10 text-yellow-400" />
        </div>
        <div>
          <p className="text-sm text-zinc-300 mt-1">
            You don’t have the necessary permissions to view this section.
          </p>
          <div className="mt-3 flex gap-3">
            <RequestAccess />
            {/* <Button
              onClick={() => navigate('/app')}
              variant="glass"
            >
              Go to Dashboard
            </Button> */}
          </div>
        </div>
      </div>
    </ContentLayout>
  );
}
